import { Select } from '~/components/Select';
import { BehaviorChartView, CONTROLS_HEIGHT } from '~/components/BehaviorChartView';
import { useSchoolBehaviorReportQuery } from '~/services/administrator/useSchoolBehaviorReportQuery';
import { useAdminTimeRange, TIME_RANGE_OPTIONS, type TimeRange } from '~/hooks/useAdminTimeRange';

import { AdminLayout } from '~/layouts/AdminLayout';

export function AdministratorDashboardPage() {
  const { timeRange, setTimeRange } = useAdminTimeRange();
  const { data, status, isFetching } = useSchoolBehaviorReportQuery({ timeRange });

  return (
    <AdminLayout activeTab="overview" scrollable={false}>
      <BehaviorChartView
        data={data}
        loading={status === 'pending' || isFetching}
        hasError={status === 'error'}
        absentAsBaseline={false}
        title="School Behavior"
        controlsLayout="stacked"
        errorMessage="Failed to load school data. Please try reloading."
        controls={
          <Select
            value={timeRange}
            onChange={(v) => setTimeRange(v as TimeRange)}
            options={TIME_RANGE_OPTIONS}
            height={CONTROLS_HEIGHT}
          />
        }
      />
    </AdminLayout>
  );
}
